import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { IBudgetLand } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetLandField } from '../../../../../queries/useBudgetLandField';

interface GuttersProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const Gutters: React.FC<GuttersProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [gutters, set_gutters] = useBudgetLandField<number>(
        propertyGuid,
        (b) => (b.values?.['Site Work']?.['Gutters'] as number) ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Site Work': { ...b.values?.['Site Work'], 'Gutters': v } } })
    );
    const label = 'Gutters';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(gutters)}
                />
            ) : (
                <MoneyBox
                    id={'gutters'}
                    allowNegative={false}
                    value={gutters}
                    onChange={(value) => set_gutters(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
